// extracted by mini-css-extract-plugin
export var bottomRightDock = "_1l-0";